/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type careTeam_PlanCareTeam$ref = any;
export type careTeam_updateCareTeamMemberRole_MutationVariables = {|
  planId: any,
  memberId: any,
  roleCode: string,
|};
export type careTeam_updateCareTeamMemberRole_MutationResponse = {|
  +careTeamMemberMutation: ?{|
    +updateCareTeamMemberRole: ?{|
      +$fragmentRefs: careTeam_PlanCareTeam$ref
    |}
  |}
|};
export type careTeam_updateCareTeamMemberRole_Mutation = {|
  variables: careTeam_updateCareTeamMemberRole_MutationVariables,
  response: careTeam_updateCareTeamMemberRole_MutationResponse,
|};
*/


/*
mutation careTeam_updateCareTeamMemberRole_Mutation(
  $planId: UUID!
  $memberId: UUID!
  $roleCode: String!
) {
  careTeamMemberMutation {
    updateCareTeamMemberRole(planId: $planId, memberId: $memberId, roleCode: $roleCode) {
      ...careTeam_PlanCareTeam
      id
    }
  }
}

fragment careTeam_PlanCareTeam on Plan {
  id
  careTeamMembers {
    id
    name
    primary
    role {
      id
      code
      value
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "memberId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "planId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "roleCode"
},
v3 = [
  {
    "kind": "Variable",
    "name": "memberId",
    "variableName": "memberId"
  },
  {
    "kind": "Variable",
    "name": "planId",
    "variableName": "planId"
  },
  {
    "kind": "Variable",
    "name": "roleCode",
    "variableName": "roleCode"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "careTeam_updateCareTeamMemberRole_Mutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CareTeamMemberMutation",
        "kind": "LinkedField",
        "name": "careTeamMemberMutation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "Plan",
            "kind": "LinkedField",
            "name": "updateCareTeamMemberRole",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "careTeam_PlanCareTeam"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "careTeam_updateCareTeamMemberRole_Mutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CareTeamMemberMutation",
        "kind": "LinkedField",
        "name": "careTeamMemberMutation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "Plan",
            "kind": "LinkedField",
            "name": "updateCareTeamMemberRole",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CareTeamMember",
                "kind": "LinkedField",
                "name": "careTeamMembers",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "primary",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CodeTablePair",
                    "kind": "LinkedField",
                    "name": "role",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "code",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "value",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1bf0d17be1530895014f7026974bbadb",
    "id": null,
    "metadata": {},
    "name": "careTeam_updateCareTeamMemberRole_Mutation",
    "operationKind": "mutation",
    "text": "mutation careTeam_updateCareTeamMemberRole_Mutation(\n  $planId: UUID!\n  $memberId: UUID!\n  $roleCode: String!\n) {\n  careTeamMemberMutation {\n    updateCareTeamMemberRole(planId: $planId, memberId: $memberId, roleCode: $roleCode) {\n      ...careTeam_PlanCareTeam\n      id\n    }\n  }\n}\n\nfragment careTeam_PlanCareTeam on Plan {\n  id\n  careTeamMembers {\n    id\n    name\n    primary\n    role {\n      id\n      code\n      value\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'c7ec889d6b3066f13bafa8c35e53c1e9';

module.exports = node;
